var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSprayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 74,
    viewBox: "0 0 53 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9974 6.68723C30.2937 6.1064 30.8062 5.66829 31.4221 5.46929C32.0381 5.27029 32.707 5.3267 33.2818 5.62611L47.3216 12.9394C47.8946 13.2379 48.3268 13.7542 48.5231 14.3747C48.7194 14.9952 48.6638 15.669 48.3684 16.2481C48.0731 16.8271 47.5622 17.2638 46.9481 17.4622C46.3341 17.6606 45.6672 17.6044 45.0943 17.3059L31.0477 9.98905C30.4747 9.69057 30.0425 9.1743 29.8462 8.55382C29.6499 7.93333 29.7055 7.25945 30.0009 6.68042L29.9974 6.68723Z",
    fill: "#092C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.88174 57.3892C0.4057 58.3167 0.115619 59.3301 0.0281492 60.3712C-0.0593211 61.4123 0.0575413 62.4606 0.372029 63.4559C0.686516 64.4513 1.19244 65.3741 1.86075 66.1713C2.52906 66.9685 3.34661 67.6246 4.26646 68.1017L13.2697 72.7922C14.1873 73.2743 15.1902 73.5683 16.2207 73.6572C17.2512 73.7461 18.2889 73.6282 19.2742 73.3103C20.2594 72.9925 21.1727 72.4808 21.9616 71.8049C22.7504 71.129 23.3992 70.3021 23.8706 69.3719L45.8978 26.1165C46.574 24.7892 46.701 23.2449 46.2509 21.823C45.8008 20.4011 44.8104 19.218 43.4974 18.5336L30.4583 11.7389C29.8078 11.3983 29.0971 11.1909 28.367 11.1285C27.637 11.0661 26.902 11.15 26.2041 11.3754C25.5062 11.6008 24.8592 11.9631 24.3002 12.4418C23.7413 12.9204 23.2813 13.5058 22.9468 14.1645L0.88174 57.3892Z",
    fill: "#092C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5946 3.32663L46.9589 4.51025L48.1302 5.15264L48.7659 3.96902L47.5946 3.32663Z",
    fill: "#092C4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.228 0.169253L41.9566 2.5365L45.4705 4.46366L46.7419 2.09641L43.228 0.169253Z",
    fill: "#092C4C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0224 3.26379L38.2597 6.54565L43.5505 9.44735L45.3132 6.16549L40.0224 3.26379Z",
    fill: "#092C4C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5269 4.93539L49.8912 6.11902L52.2338 7.40379L52.8695 6.22017L50.5269 4.93539Z",
    fill: "#092C4C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprayIcon);
export default __webpack_public_path__ + "static/media/sprayIcon.6ce6557ed5c9282a472826a5a77caa66.svg";
export { ForwardRef as ReactComponent };